import * as React from "react"
import Svg, { Path } from "react-native-svg"

function HomeIconUnfocused(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.329 3.528a1.298 1.298 0 011.42.283v.001l7.953 7.953a1.298 1.298 0 01-.419 2.123 1.298 1.298 0 01-1.419-.283l-.001-.001-7.035-7.041-7.037 7.042a1.3 1.3 0 11-1.839-1.838l7.954-7.955h.002c.12-.122.263-.218.42-.284zm8.407 9.21z"
        fill="#8B8D98"
      />
      <Path
        d="M6.686 13.898c0-.227.09-.445.25-.606l4.31-4.31a.857.857 0 011.188-.023l4.69 4.33c.176.162.276.39.276.63v5.195a.857.857 0 01-.857.858h-9a.857.857 0 01-.857-.858v-5.216z"
        fill="#CDCED6"
      />
    </Svg>
  )
}

export default HomeIconUnfocused


